import { Box, ButtonBase } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';

interface Props {
  onClick?: () => void;
}

// Labelled pill on desktop, icon only on mobile.
const CalendarButton = ({ onClick }: Props) => {
  const intl = useIntl();

  return (
    <ButtonBase
      component={LinkUnstyled}
      href={Routes.EventsCalendar}
      aria-label={intl.formatMessage({ id: 'events.calendar.cta' })}
      onClick={onClick}
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        gap: theme.spacing(1.5),
        width: 52,
        height: 40,
        borderRadius: 999,
        backgroundColor: 'grey.900',
        color: 'common.white',
        ...theme.typography.button,
        whiteSpace: 'nowrap',
        [theme.breakpoints.up('md')]: {
          width: 'auto',
          height: 48,
          padding: theme.spacing(0, 2.5),
          fontSize: theme.typography.button.fontSize,
        },
        '@media (hover: hover)': { '&:hover': { opacity: 0.8 } },
      })}
    >
      <Icon name="Calendar" fontSize={24} />

      <Box component="span" sx={{ display: { xs: 'none', md: 'block' } }}>
        <FormattedMessage id="events.calendar.cta" />
      </Box>
    </ButtonBase>
  );
};

export default CalendarButton;
